import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

export default function UnpickedItemsErrorModal({ open, onClose, onRemoveItems }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle sx={{ p: 3 }}>
        <Typography align="center" color="error" sx={{ px: 2, fontWeight: 500, fontSize: 22 }}>
          Error
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ position: "absolute", right: 16, top: 16 }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" pb={2}>
          <Typography
            color="textPrimary"
            align="center"
            sx={{ mb: 2, maxWidth: 500, fontWeight: 500 }}
          >
            One or more items have not been picked.
          </Typography>
          <Typography color="textPrimary" align="center" sx={{ mb: 2, maxWidth: 500 }}>
            Please pick all items before submitting.
          </Typography>
          {onRemoveItems && (
            <>
              <Typography
                color="textSecondary"
                align="center"
                variant="body2"
                sx={{ mb: 2, maxWidth: 500 }}
              >
                If the customer no longer needs them, you can remove the unpicked items and return
                them to available stock.
              </Typography>
              <Box display="flex" flexDirection="column" gap={1} width="100%" maxWidth={280}>
                <Button variant="contained" onClick={onClose}>
                  Return to Pick
                </Button>
                <Button variant="outlined" onClick={onRemoveItems}>
                  Remove Unpicked Items
                </Button>
              </Box>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
